import React, { useState, useEffect, useCallback } from 'react';
import './role.scss';

// images
import dronePilotImg from "../../../../assets/images/roles_img/drone_pilot.png";
import droneOwnerImg from "../../../../assets/images/roles_img/droneowner.png";
import serviceCompanyImg from "../../../../assets/images/roles_img/service_provider.png";
import gisEngineerImg from "../../../../assets/images/roles_img/gisengineer.png";
import dgpsImg from "../../../../assets/images/roles_img/dgps.png";
import photogrammetristImg from "../../../../assets/images/roles_img/photogramatery.png";
import lidarImg from "../../../../assets/images/roles_img/lidar.png";
import thermalImg from "../../../../assets/images/roles_img/thermal.png";
import dronePhotographerImg from "../../../../assets/images/roles_img/drone_photographer.png";
import videographerImg from "../../../../assets/images/roles_img/videographer.png";
import videoEditorImg from "../../../../assets/images/roles_img/videoeditor.png";
import manufacturerImg from "../../../../assets/images/roles_img/manufacturing.png";
import insuranceProviderImg from "../../../../assets/images/roles_img/insurance.png";
import trainingCenterImg from "../../../../assets/images/roles_img/trainings.png";
import Button from '../../../../components/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useUpdatePartnerRoles } from '../../../../hooks/partnerHook/useRoles';
import { closeRoles } from '../../../../store/Partner/modalSlice';

function Role() {
    const { mutate: updateRoles, isSuccess, isPending, isError } = useUpdatePartnerRoles()
    const [groupedRoles, setGroupedRoles] = useState({});
    const [selectedRoles, setSelectedRoles] = useState([]); // Storing the entire role object
    const allRoles = useSelector((state) => state.siteData.partnerRoles);
    const partnerSelectedRoles = useSelector((state) => state.partner.user.partner.roles);
    

    const dispatch = useDispatch();

    const handleCloseRoles = () => {
        dispatch(closeRoles());
    };

    const roleImg = {
        "Drone Pilot": dronePilotImg,
        "Drone Owner": droneOwnerImg,
        "Service Company": serviceCompanyImg,
        "GIS Engineer": gisEngineerImg,
        "DGPS Expert": dgpsImg,
        'Photogrammetrist': photogrammetristImg,
        "LiDAR Engineer": lidarImg,
        "Thermal Engineer": thermalImg,
        "Drone Photographer": dronePhotographerImg,
        "Videographer": videographerImg,
        "Video Editor": videoEditorImg,
        'Manufacturer': manufacturerImg,
        "Insurance Provider": insuranceProviderImg,
        "Training Center": trainingCenterImg,
    };



useEffect(() => {
    if (allRoles.length > 0 && partnerSelectedRoles?.length > 0) {
        const preselected = allRoles.filter(role =>
            partnerSelectedRoles.some(selected => selected.role_id === role.role_id)
        );
        setSelectedRoles(preselected);
    }
}, [allRoles, partnerSelectedRoles]);

    // Group roles by category
    useEffect(() => {
        if (allRoles.length > 0) {
            const grouped = allRoles.reduce((acc, role) => {
                if (!acc[role.role_category]) {
                    acc[role.role_category] = [];
                }
                acc[role.role_category].push(role);
                return acc;
            }, {});
            setGroupedRoles(grouped);
        }
    }, [allRoles]);

    // Handle selecting/unselecting a role (storing the whole object)
    const handleUserRole = useCallback((role) => {
        setSelectedRoles((prevSelectedRoles) => {
            if (prevSelectedRoles.some((selected) => selected.role_id === role.role_id)) {
                return prevSelectedRoles.filter((selected) => selected.role_id !== role.role_id);
            } else {
                return [...prevSelectedRoles, role];
            }
        });
    }, []);

    // Check if the role is selected
    const isRoleSelected = (roleId) => selectedRoles.some((role) => role.role_id === roleId);

    // Handle role submission
    const handleRoleSubmit = () => {
        if (selectedRoles.length > 0) {
            console.log("Selected Roles:", selectedRoles);
            updateRoles(selectedRoles)
        }
    };

    useEffect(() => {
        if(isSuccess){
                handleCloseRoles();
            }
    }, [isSuccess])

    return (
        <div className='container-background content-center'>
            <div className="roles-container">
                <div className="close-btn-roles">
                    <Button label={'Close'} customStyle={{ background: '#FF5757', color: 'white' }} handleClick={handleCloseRoles} />
                </div>
                <div className="role-list-container">
                    <div className="page-header">
                        <h2 className='page-heading'>Select your roles</h2>
                        <p className='page-sub-heading'>Choose minimum one of the roles to continue...</p>
                    </div>
                    <div className="roles-list">
                        {Object.keys(groupedRoles).map((category, index) => (
                            <div key={index} className='roles-category-container'>
                                <h3>{category}</h3>
                                <div className='roles-data-container'>
                                    {groupedRoles[category].map((role) => (
                                        <div
                                            key={role.role_id}
                                            className={`roles ${isRoleSelected(role.role_id) ? 'selected' : ''}`}
                                            onClick={() => handleUserRole(role)}
                                        >
                                            <div className='role-img'>
                                                <img src={roleImg[role.role_name]} alt={role.role_name} />
                                            </div>
                                            <div className="role-data">
                                                <h5>{role.role_name}</h5>
                                                <p>{role.role_description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="role-submit-btn-container">
                    <Button
                        label={'Submit'}
                        handleClick={handleRoleSubmit}
                        customStyle={{
                            border: '1px solid grey'
                        }}
                    />
                </div>
            </div>
        </div>
    );
}

export default Role;
